/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";

export type EvaluateOpenAPIv3Form = {
  /**
   * The ID of the uploaded OpenAPI document asset to evaluate.
   */
  assetId: string;
  /**
   * The display name of the source. Defaults to the deployed name or the slug.
   */
  name?: string | undefined;
  /**
   * The slug of the OpenAPI source the document will replace. A slug that is not in the active deployment is evaluated as a new source.
   */
  slug: string;
};

/** @internal */
export type EvaluateOpenAPIv3Form$Outbound = {
  asset_id: string;
  name?: string | undefined;
  slug: string;
};

/** @internal */
export const EvaluateOpenAPIv3Form$outboundSchema: z.ZodMiniType<
  EvaluateOpenAPIv3Form$Outbound,
  EvaluateOpenAPIv3Form
> = z.pipe(
  z.object({
    assetId: z.string(),
    name: z.optional(z.string()),
    slug: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      assetId: "asset_id",
    });
  }),
);

export function evaluateOpenAPIv3FormToJSON(
  evaluateOpenAPIv3Form: EvaluateOpenAPIv3Form,
): string {
  return JSON.stringify(
    EvaluateOpenAPIv3Form$outboundSchema.parse(evaluateOpenAPIv3Form),
  );
}
